import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../environments/environment";
import {MatomoService} from "../../services/matomo/matomo.service";

@Component({
  selector: 'app-registration-success',
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss'
})
export class RegistrationSuccessComponent implements OnInit{
  plan = 'FREE';
  source = 'direct';
  trialEndsAt: Date | null = null;
  readonly appStoreUrl = 'https://apps.apple.com/de/app/docuty/id6752243668';
  readonly playStoreUrl = 'https://play.google.com/store/apps/details?id=de.docuty.docutyapp';

  constructor(
    private route: ActivatedRoute,
    private matomo: MatomoService
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    this.plan = (params.get('plan') || 'FREE').toUpperCase();
    // Stripe hängt ?session_id=... an die returnUrl, die bereits ? enthält → source wäre "stripe?session_id=..."
    this.source = (params.get('source') || 'direct').replace(/\?.*$/, '').toLowerCase();

    // DOCU-1041: nur beim Trial gesetzt. Ein unbrauchbarer Wert darf die Seite nicht
    // kaputtmachen — dann bleibt nur das Enddatum weg, der Trial-Text steht trotzdem.
    const rawTrialEnd = params.get('trialEndsAt');
    if (rawTrialEnd) {
      const parsed = new Date(rawTrialEnd);
      this.trialEndsAt = isNaN(parsed.getTime()) ? null : parsed;
    }

    // DOCU-1035: Hier und nur hier wird der Abschluss gemeldet. Diese Seite ist
    // der einzige Punkt, den beide Wege durchlaufen — der direkte (FREE/Trial)
    // und der ueber Stripe, der zwischendurch die Seite verlaesst.
    this.matomo.trackRegistrationCompleted(this.plan, this.isTrial);
  }

  /** DOCU-1041: true, wenn die Registrierung eine 30-tägige Testphase gestartet hat. */
  get isTrial(): boolean {
    return this.source === 'trial';
  }

  get isMobile(): boolean {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  get isPaidPlan(): boolean {
    return this.plan === 'BASIC' || this.plan === 'PRO';
  }

  openAppleStore(): void {
    window.open(this.appStoreUrl, '_blank', 'noopener');
  }

  openPlayStore(): void {
    window.open(this.playStoreUrl, '_blank', 'noopener');
  }

  continueToLogin(): void {
    window.location.href = environment.backofficeUrl;
  }
}
